import React from 'react'

const Login = () => {
  return (
    <div style={{width:"100vw",height:"100vh"}}>
      Login
Login
    </div>
  )
}

export default Login
